import AccountManageContainer from "components/B/accountManage/AccountManageContainer";
import MainHeader from "components/common/MainHeader";
import React from "react";

const AccountManageRouter = () => {
    return (
        <>
            <AccountManageContainer />
        </>
    );
};

export default AccountManageRouter;
